import React from 'react';
import { useTranslation } from 'react-i18next';

import CircleArmPrice from '../../../../img/circly_arm_price.svg';
import useStyles from '../makeStyles';

const OfferInfo = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.offerContainer}>
      <div className={classes.offerTitle}>
        <img src={CircleArmPrice} alt="" />
        {t('paymentMethods.isFree')}
      </div>
    </div>
  );
};

export default OfferInfo;
